import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
} from '@angular/core';

interface RecommendationItem {
  slug: string;
  title: string;
  published_at: string;
  user: {
    slug: string;
    name: string;
  };
}

@Component({
  selector: 'ut-recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RecommendationsComponent {
  @Input() items: RecommendationItem[] = [];

  constructor(
    @Inject('$analytics') private $analytics: any,
  ) {}

  track(item: RecommendationItem): void {
    if (this.$analytics) {
      this.$analytics.eventTrack('click', {
        category: 'Article Recommendation',
        label: item.slug,
      });
    }
  }

  trackBySlug(index: number, item: RecommendationItem): string {
    return item.slug;
  }
}
